import React from "react";
import FileUploaderPageContent from "../videos";

const AssetsImport = () => {
	return <FileUploaderPageContent />;
};

export default AssetsImport;
